<p class="caption">
  Need help?
  <a *dsPartnerAFI [href]="amfamDotCom + 'contact?UTM_Source=MyAccount'" target="amfam"
    >Contact us.</a
  >
  <a *dsPartnerConnect [dsRouterLink]="'/contact-us?UTM_Source=MyAccount'">Contact us.</a>
</p>
